import { render, staticRenderFns } from "./UserScreen.vue?vue&type=template&id=20e1b103"
import script from "./UserScreen.vue?vue&type=script&lang=js"
export * from "./UserScreen.vue?vue&type=script&lang=js"
import style0 from "./UserScreen.vue?vue&type=style&index=0&id=20e1b103&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports